<template>
	<section class="other_page_banner kiosk_sec banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{ $t('new_ui.personal_jpys_page.section_banner.title.one') }}
						</h5>
						<h2>
							{{
								$t('new_ui.personal_jpys_page.section_banner.main_title.one')
							}}
							<br />{{
								$t('new_ui.personal_jpys_page.section_banner.main_title.two')
							}}
						</h2>

						<p>
							{{ $t('new_ui.personal_jpys_page.section_banner.paragraph.one') }}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2 wallet_desk">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2 wallet_mob">
					<div class="ban_rt">
						<img :src="img.image5" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="offine_store_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="offline_store_inn">
						<span>{{
							$t('new_ui.personal_jpys_page.offline_store_sec.title.one')
						}}</span>
						<h4>
							{{
								$t('new_ui.personal_jpys_page.offline_store_sec.sub_title.one')
							}}
							<span>{{
								$t('new_ui.personal_jpys_page.offline_store_sec.sub_title.two')
							}}</span>
							{{
								$t(
									'new_ui.personal_jpys_page.offline_store_sec.sub_title.three',
								)
							}}
							<span>{{
								$t('new_ui.personal_jpys_page.offline_store_sec.sub_title.four')
							}}</span>
							{{
								$t('new_ui.personal_jpys_page.offline_store_sec.sub_title.five')
							}}
						</h4>
						<img :src="img.image2" alt="Logo" />
						<p>
							{{
								$t('new_ui.personal_jpys_page.offline_store_sec.paragraph.one')
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="question_sec question_trade">
		<div class="container">
			<div class="row">
				<div class="col-sm-5 question_desk">
					<div class="question_lt">
						<img :src="img.image3" alt="" />
					</div>
				</div>
				<div class="col-sm-5 question_mob">
					<div class="question_lt">
						<img :src="img.image6" alt="" />
					</div>
				</div>
				<div class="col-sm-7">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.personal_jpys_page.question_trade.title.one')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									<span>{{
										$t('new_ui.personal_jpys_page.question_trade.sub_title.one')
									}}</span>
									{{
										$t('new_ui.personal_jpys_page.question_trade.sub_title.two')
									}}
									<span>{{
										$t(
											'new_ui.personal_jpys_page.question_trade.sub_title.three',
										)
									}}</span>
									{{
										$t(
											'new_ui.personal_jpys_page.question_trade.sub_title.four',
										)
									}}
								</h4>
								<p>
									{{
										$t('new_ui.personal_jpys_page.question_trade.paragraph.one')
									}}
								</p>
								<p>
									{{
										$t('new_ui.personal_jpys_page.question_trade.paragraph.two')
									}}
								</p>
								<div class="starting_to_btn">
									<a href="/auth/register">{{
										$t(
											'new_ui.personal_jpys_page.question_trade.cta_buttons.one',
										)
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="charging_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="charging_lt">
						<span
							>{{ $t('new_ui.personal_jpys_page.charging_sec.title') }}
						</span>
						<div class="charging_lt_txt">
							<h4>
								{{ $t('new_ui.personal_jpys_page.charging_sec.sub_title.one') }}
							</h4>
							<p>
								{{ $t('new_ui.personal_jpys_page.charging_sec.paragraph.one') }}
							</p>
							<p>
								{{ $t('new_ui.personal_jpys_page.charging_sec.paragraph.two') }}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t('new_ui.personal_jpys_page.charging_sec.cta_buttons.one')
								}}</a>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="charging_rt">
						<img :src="img.image4" alt="" />
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.personal_jpys_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t('new_ui.personal_jpys_page.section_newsletter.title.one')
								}}</span>
								{{
									$t('new_ui.personal_jpys_page.section_newsletter.title.two')
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_jpys_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_jpys_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_jpys_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_jpys_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import addone from '@/assets/images/sub/addone_ban.png';
import store from '@/assets/images/sub/store.png';
import kiosk from '@/assets/images/sub/kiosk.png';
import charge from '@/assets/images/sub/charging.png';
import fullwallet from '@/assets/images/sub/full_wallet.png';
import jpys from '@/assets/images/sub/jpys.png';

export default {
	data: () => {
		return {
			img: {
				image1: addone,
				image2: store,
				image3: kiosk,
				image4: charge,
				image5: fullwallet,
				image6: jpys,
			},
		};
	},
};
</script>
